import { Icons } from '@silverfort/sf-components';
import { BlockPage } from '../../../../routings/pages/BlockPage/BlockPage';
import mainImg from './mainImage.png';

export const OnPremNHIBlockPage: React.FC = () => {
    const topics = [
        'Discover Non-human identities automatically across your on-prem and cloud environments',
        'Eliminate non-human identity risk',
        'Enforce Virtual Fencing on your Active Directory Service Accounts to prevent lateral movement at scale'
    ];

    return (
        <BlockPage
            leftContent={{
                title: 'Non-Human Identities',
                image: mainImg
            }}
            rightContent={{
                icon: Icons.ServiceAccountRobot,
                title: 'Secure your NHI with Silverfort',
                description: 'Detect Cloud NHIs and protect your Active Directory Service Accounts in one unified view',
                topics: topics,
                accessLink: 'https://www.silverfort.com/nhi-signup/?utm_source=PQL&utm_content=main'
            }}
        />
    );
};
